import { render, staticRenderFns } from "./CollectLog.vue?vue&type=template&id=2564cb42&"
import script from "./CollectLog.vue?vue&type=script&lang=js&"
export * from "./CollectLog.vue?vue&type=script&lang=js&"
import style0 from "./CollectLog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports